import cn from 'classnames';
import { Icon } from 'ui';
import { DirectMessageButtonNode } from '../direct-message-button-node';

const IconDirectMessageButton = ({
  small = false,
  type = 'link-secondary',
  user,
  viewer,
}: {
  small?: boolean;
  type?: 'link-secondary' | 'tertiary' | 'text';
  user: { _id: string; email: string; firstName: string; lastName: string };
  viewer: { _id: string };
}) => (
  <DirectMessageButtonNode
    className={cn('icon-direct-message-button-node', { 'icon-direct-message-button-node--small': small })}
    icon={<Icon icon="comment-line" />}
    type={type}
    user={user}
    viewer={viewer}
  />
);

export default IconDirectMessageButton;
